module.exports = __webpack_public_path__ + "static/img/erweima.a2892c9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/about/erweima.png
// module id = l8xk
// module chunks = 1